const SETTINGS_LOCAL_STORAGE = 'settings';

export default SETTINGS_LOCAL_STORAGE;
